import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './locales/en-US.json';
import ptBR from './locales/pt-BR.json';
import es from './locales/es.json';
import { DEFAULT_LOCALE, type SupportedLocale, matchLocale, resolveLocale } from './locales';

export const resources = {
  'pt-BR': { translation: ptBR },
  'en-US': { translation: enUS },
  es: { translation: es },
} as const;

let manualLocaleChange = false;

export function wasLocaleChangedManually(): boolean {
  return manualLocaleChange;
}

export function resetManualLocaleFlag(): void {
  manualLocaleChange = false;
}

function detectInitialLocale(): SupportedLocale {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;
  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const candidate of candidates) {
    const matched = matchLocale(candidate);
    if (matched) return matched;
  }
  return DEFAULT_LOCALE;
}

function syncDocumentLanguage(locale: string): void {
  if (typeof document !== 'undefined') document.documentElement.lang = locale;
}

if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init({
    resources,
    lng: detectInitialLocale(),
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: Object.keys(resources),
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  i18next.on('languageChanged', syncDocumentLanguage);
  syncDocumentLanguage(i18next.language);
}

export async function applyPersonLocale(locale: string | undefined | null): Promise<void> {
  const resolved = resolveLocale(locale);
  if (i18next.language === resolved) return;
  await i18next.changeLanguage(resolved);
}

export async function changeLanguage(locale: SupportedLocale): Promise<void> {
  manualLocaleChange = true;
  await i18next.changeLanguage(locale);
}

export default i18next;
